import { api } from "@/api";

// Fiches déjà lues (copie locale) : la fiche s'affiche sans attendre, le survol et l'aperçu réutilisent la même donnée
const cache = new Map();
const inflight = new Map();

export const cachedLead = (id) => cache.get(Number(id));
export const rememberLead = (data) => { if (data?.lead?.id) cache.set(Number(data.lead.id), data); };

export function prefetchLead(id) {
  id = Number(id);
  if (cache.has(id)) return Promise.resolve(cache.get(id));
  if (!inflight.has(id)) {
    inflight.set(id, api.get(`/pipeline/leads/${id}`, { params: { live: false } })
      .then(({ data }) => { rememberLead(data); return data; })
      .finally(() => inflight.delete(id)));
  }
  return inflight.get(id);
}
